module.exports = __webpack_public_path__ + "static/img/meu_inss_cnis.7c7e6c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meu_inss_cnis.png
// module id = t4Ic
// module chunks = 1